import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";

@Component({
  selector: "app-visit-store-button",
  standalone: true,
  imports: [CommonModule, ButtonModule, TooltipModule],
  template: `
    <div *ngIf="shouldShowButton && siteUrl" class="visit-store-container">
      <button
        pButton
        [label]="'Visit Store'"
        icon="pi pi-external-link"
        class="p-button-outlined p-button-sm visit-store-btn"
        [ngClass]="{ 'mobile-btn': true }"
        (click)="visitStore()"
        pTooltip="Open store in new tab"
        tooltipPosition="bottom"
      ></button>
    </div>
  `,
  styles: [
    `
      .visit-store-container {
        display: flex;
        align-items: center;
      }

      .visit-store-btn {
        background: linear-gradient(
          135deg,
          #667eea 0%,
          #764ba2 100%
        ) !important;
        border: none !important;
        color: white !important;
        font-weight: 600 !important;
        font-size: 0.75rem !important;
        padding: 0.25rem 0.625rem !important;
        border-radius: 0.375rem !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        box-shadow: 0 2px 8px 0 rgba(102, 126, 234, 0.35) !important;
        position: relative !important;
        overflow: hidden !important;
        animation:
          pulse-glow 2s ease-in-out infinite alternate,
          subtle-pulse 3s ease-in-out infinite !important;
        height: 1.75rem !important;
        display: inline-flex !important;
        align-items: center !important;
      }

      .visit-store-btn:hover {
        transform: scale(1.05) !important;
        box-shadow: 0 4px 16px 0 rgba(102, 126, 234, 0.5) !important;
        background: linear-gradient(
          135deg,
          #5a67d8 0%,
          #6b46c1 100%
        ) !important;
      }

      .visit-store-btn:active {
        transform: scale(0.98) !important;
        transition: transform 0.1s !important;
      }

      .visit-store-btn::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          90deg,
          transparent,
          rgba(255, 255, 255, 0.2),
          transparent
        );
        transition: left 0.6s;
      }

      .visit-store-btn:hover::before {
        left: 100%;
      }

      @keyframes pulse-glow {
        0% {
          box-shadow: 0 2px 8px 0 rgba(102, 126, 234, 0.35);
        }
        100% {
          box-shadow: 0 2px 12px 0 rgba(102, 126, 234, 0.5);
        }
      }

      @keyframes subtle-pulse {
        0%,
        100% {
          transform: scale(1);
        }
        50% {
          transform: scale(1.04);
        }
      }

      .visit-store-btn .p-button-icon {
        margin-right: 0.25rem !important;
        font-size: 0.625rem !important;
      }

      .visit-store-btn .p-button-label {
        font-weight: 600 !important;
        font-size: 0.75rem !important;
      }

      /* Mobile responsive styles */
      @media (max-width: 768px) {
        .visit-store-btn.mobile-btn {
          font-size: 0.6875rem !important;
          padding: 0.1875rem 0.5rem !important;
          height: 1.5rem !important;
        }

        .visit-store-btn.mobile-btn .p-button-icon {
          margin-right: 0.1875rem !important;
          font-size: 0.5625rem !important;
        }

        .visit-store-btn.mobile-btn .p-button-label {
          font-size: 0.6875rem !important;
        }
      }
    `,
  ],
})
export class VisitStoreButtonComponent {
  @Input() shouldShowButton = false;
  @Input() siteUrl: string | null = null;

  visitStore(): void {
    if (this.siteUrl) {
      window.open(this.siteUrl, "_blank", "noopener,noreferrer");
    }
  }
}
